import {Card, CardContent, CardHeader, CardTitle} from '@/components/ui/card'
import { Slider } from '@/components/ui/slider'
import {Badge} from "@/components/Badge.tsx";
import {CalculatorIcon} from "lucide-react";
import { useCalculator } from '@/contexts/CalculatorContext';

export function MarginSliderCard() {
  const { 
    margin, 
    setMargin, 
    getMarginPercentage,
    currentPeriod,
    getAllPeriods,
    getNastupyPercentage
  } = useCalculator()

  const periodData = getAllPeriods()
  const previousPeriod = currentPeriod > 0 ? periodData[currentPeriod - 1] : null
  const previousIsKpiMet = previousPeriod ? previousPeriod.isKpiMet : false
  const previousBonus = previousPeriod ? previousIsKpiMet ? getNastupyPercentage(previousPeriod.nastupy) : 0 : 0
  const currentPercentage = getMarginPercentage(margin)
  const totalPercentage = previousPeriod ? (Number(currentPercentage) + Number(previousBonus)).toFixed(1) : currentPercentage

  return (
    <Card className="w-full">
      <CardHeader>
        <div className="flex items-center gap-2">
          <CalculatorIcon className="w-5 h-5" />
          <div>
            <CardTitle>1. složka</CardTitle>
            <p className="text-sm text-muted-foreground mt-1">
              Maržový bonus - vypočten per nástup
            </p>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        {/*{previousPeriod && (*/}
        {/*  <div className="p-3 bg-blue-50 border border-blue-200 rounded-md">*/}
        {/*    <div className="flex justify-between items-center">*/}
        {/*      <span className="text-sm text-blue-700">Bonus z předchozího období</span>*/}
        {/*      <span className="text-lg font-bold text-blue-700">+{previousBonus}%</span>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*)}*/}
        <div>
          <div className="text-center">
            <div className="text-3xl font-bold text-primary">
              {margin.toLocaleString()} Kč
            </div>
            <div className="flex justify-center items-center gap-2 text-sm text-muted-foreground mt-1">
              <span>({currentPercentage}% + {previousBonus}% = {totalPercentage}%)</span>
            </div>
          </div>
          <Slider
            value={[margin]}
            onValueChange={(values) => setMargin(values[0])}
            min={0}
            max={3501}
            step={100}
            className="w-full p-2"
          />
          <div className="flex justify-between text-sm text-muted-foreground">
            <span>0 Kč</span>
            <span>3501+ Kč</span>
          </div>
          <div className="flex justify-between mt-4">
            <Badge label="36 měsíců" variant="yellow" />
            <Badge label="Každé 3 měsíce" variant="blue" />
          </div>
        </div>
      </CardContent>
    </Card>
  )
} 